import { storage } from "../firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

/**
 * Get image dimensions from a File object
 * @param {File} file - The image file
 * @returns {Promise<{width: number, height: number}>}
 */
const getImageDimensions = (file) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      resolve({ width: img.width, height: img.height });
      URL.revokeObjectURL(img.src);
    };
    img.onerror = () => {
      resolve({ width: 800, height: 600 });
    };
    img.src = URL.createObjectURL(file);
  });
};

/**
 * Upload a chat image to Firebase Storage
 * @param {string} chatType - The type of chat: 'events', 'groups', or 'matches'
 * @param {string} chatId - The chat/conversation ID
 * @param {File} file - The image file to upload (already resized)
 * @returns {Promise<{type: string, url: string, width: number, height: number}>}
 */
export const uploadChatImage = async (chatType, chatId, file) => {
  const filename = `${crypto.randomUUID()}.jpg`;
  const filePath = `chatImages/${chatType}/${chatId}/${filename}`;

  const dimensions = await getImageDimensions(file);

  const storageRef = ref(storage, filePath);
  await uploadBytes(storageRef, file, {
    cacheControl: "public, max-age=31536000, immutable",
    contentType: file.type,
  });
  const url = await getDownloadURL(storageRef);

  return {
    type: "image",
    url,
    width: dimensions.width,
    height: dimensions.height
  };
};
